import React, { useEffect, useRef, useState, useContext, useMemo } from "react";
import { useTheme } from "@mui/styles";
import _ from "lodash";
import ImagePreview from "features/metadesk/components/ImagePreview";
import Box from "@mui/material/Box";
import { formatDate, hexToRgb } from "features/helpers/utils";

import { get, isEmpty } from "lodash-es";

import {
  StyledDescription,
  StyledNotificationCard,
} from "./WidgetPreview.styles";
import { useIntl } from "react-intl";
import parse from "html-react-parser";
import { useFetchWidgetConfig } from "features/metadesk/redux/hooks";
import { useOutletContext } from "react-router";
import NotificationDetailContext from "features/metadesk/Notification/NotificationDetail/NotificationDetail.context";

const WidgetPreview = ({ disabled }) => {
  const { formatMessage } = useIntl();
  const [entityName] = useOutletContext();
  const theme = useTheme();
  const { formData } = useContext(NotificationDetailContext);
  const { title, content, image, buttonText, buttonUrl, sendTime } = formData;

  const [widgetTab, setWidgetTab] = useState(0);
  const tabsArray = [
    formatMessage({ id: "campaignBuild.widgetPreview.cardPageTab" }),
    formatMessage({ id: "campaignBuild.widgetPreview.detailPageTab" }),
  ];

  const { widgetConfig, fetchWidgetConfig } = useFetchWidgetConfig();
  useEffect(() => {
    fetchWidgetConfig({ entityName });
  }, []);

  const widgetConfigData = useMemo(
    () => ({
      isLight: get(widgetConfig?.[0], "colorTheme.mode", "light") === "light",
      primaryColor: get(
        widgetConfig?.[0],
        "colorTheme.primaryColor",
        "#007AFF"
      ),
    }),
    [widgetConfig]
  );

  const renderWidget = () => {
    const { isLight = true, primaryColor } = widgetConfigData;
    return (
      <Box>
        <Box
          className="card"
          sx={{
            height: "559px",
            width: "325px",
            padding: 0,
            bgcolor: isLight ? "#fff" : "#121212",
            position: "relative",
            borderRadius: "9.75px",
            overflow: "hidden",
            margin: "0 auto",
          }}
        >
          <Box
            sx={{
              background: isLight ? primaryColor : "#2E2E2E",
              height: 52,
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: theme.customColors.white,
              fontSize: "15px",
              fontWeight: "600",
              position: "relative",
            }}
          >
            {widgetTab === 1 && (
              <i
                className="meta-crm-icon-ic_arrow-left font-size-20"
                style={{ position: "absolute", left: "13px" }}
              />
            )}
            {formatMessage({ id: "global.serviceWidget.subtitle" })}
          </Box>
          {widgetTab === 0 && (
            <>
              <Box
                p="19.5px 19.5px 69.5px"
                sx={{ overflowY: "auto" }}
                height="507px"
              >
                <Box
                  mb="9.75px"
                  color={isLight ? "#000" : "rgba(255,255,255,0.87)"}
                  fontSize={13}
                  fontWeight={700}
                >
                  {formatMessage({
                    id: "campaignBuild.widgetPreview.cardPage.newest",
                  })}
                </Box>
                <StyledNotificationCard isLight={isLight}>
                  {image ? (
                    <Box
                      component={"img"}
                      src={image}
                      width="100%"
                      height="130px"
                      sx={{ objectFit: "cover" }}
                    />
                  ) : (
                    <Box
                      width="100%"
                      height="130px"
                      sx={{ overflow: "hidden" }}
                    >
                      <Box
                        style={{
                          transform: "scale(1.5)",
                          width: "100%",
                          height: "100%",
                          borderRadius: "50%",
                          background: `radial-gradient(50% 50% at 50% 50%, ${hexToRgb(
                            primaryColor,
                            0.8
                          )} 0%, rgba(255, 255, 255, 0.00) 100%)`,
                        }}
                      />
                    </Box>
                  )}

                  <Box
                    width="100%"
                    height="67.5px"
                    p="9.75px"
                    fontSize="9.75px"
                  >
                    <Box display="flex" alignItems="center" mb="6px">
                      <Box
                        bgcolor="#FC5555"
                        width="7px"
                        height="7px"
                        borderRadius="50%"
                        mr="6.5px"
                        flexShrink={0}
                      />
                      {title ? (
                        <Box
                          color={isLight ? "#222" : "rgba(255, 255, 255, 0.87)"}
                          fontWeight={700}
                          className="truncate"
                        >
                          {title}
                        </Box>
                      ) : (
                        <Box
                          width="112px"
                          height="12px"
                          bgcolor={isLight ? "#EDEDED" : "#373737"}
                          borderRadius="8px"
                        />
                      )}
                    </Box>
                    {content ? (
                      <Box
                        color={isLight ? "#555" : "rgba(255, 255, 255, 0.60)"}
                        fontWeight={400}
                        sx={{
                          wordBreak: "break-word",
                        }}
                        className="line-clamp-2"
                      >
                        {parse(content)}
                      </Box>
                    ) : (
                      <Box
                        width="100%"
                        height="30px"
                        bgcolor={isLight ? "#F7F7F7" : "#373737"}
                        borderRadius="8px"
                      />
                    )}
                  </Box>
                </StyledNotificationCard>
                <Box
                  mt="13px"
                  mb="9.75px"
                  color={isLight ? "#000" : "rgba(255,255,255,0.87)"}
                  fontSize={13}
                  fontWeight={700}
                >
                  {formatMessage({
                    id: "campaignBuild.widgetPreview.cardPage.previous",
                  })}
                </Box>
                <StyledNotificationCard isLight={isLight}>
                  <Box
                    width="100%"
                    height="130px"
                    bgcolor={isLight ? "#F3F3F3" : "#2D2D2D"}
                  />
                  <Box
                    width="100%"
                    height="49px"
                    p="9.75px"
                    bgcolor={isLight ? "#fff" : "#232323"}
                  >
                    <Box
                      width="59px"
                      height="12px"
                      bgcolor={isLight ? "#F3F3F3" : "#373737"}
                      borderRadius="20px"
                      mb="4px"
                    />
                    <Box
                      width="100%"
                      height="12px"
                      bgcolor={isLight ? "#F3F3F3" : "#373737"}
                      borderRadius="20px"
                    />
                  </Box>
                </StyledNotificationCard>
              </Box>
              <Box
                height="65px"
                width="100%"
                position="absolute"
                bottom={0}
                bgcolor={isLight ? "#fff" : "#2e2e2e"}
                borderTop={isLight ? "0.813px solid #F2F2F2" : "none"}
                boxShadow={
                  isLight
                    ? "0px -4.063px 16.25px 0px rgba(0, 0, 0, 0.05);"
                    : "none"
                }
                px="23px"
                className="item-flex"
                justifyContent="space-between"
              >
                <Box flex={1} textAlign="center" fontSize={11} color="#777">
                  <img src={require("assets/img/ic_home.svg").default} />
                  <Box mt="3.25px">
                    {formatMessage({ id: "campaignBuild.widgetPreview.home" })}
                  </Box>
                </Box>
                <Box flex={1} textAlign="center" fontSize={11} color="#777">
                  <img src={require("assets/img/ic_file.svg").default} />
                  <Box mt="3.25px">
                    {formatMessage({
                      id: "campaignBuild.widgetPreview.tickets",
                    })}
                  </Box>
                </Box>
                <Box
                  flex={1}
                  textAlign="center"
                  fontSize={11}
                  color={isLight ? "rgba(17, 17, 17, 0.87)" : "#fff"}
                >
                  <Box position="relative" mx="auto" width="fit-content">
                    {isLight ? (
                      <img
                        src={require("assets/img/ic_bell_hover.svg").default}
                      />
                    ) : (
                      <img
                        src={require("assets/img/ic_bell_hover_w.svg").default}
                      />
                    )}
                    <Box
                      position="absolute"
                      right={"-2px"}
                      top={"-2px"}
                      bgcolor="#FC5555"
                      width="7px"
                      height="7px"
                      borderRadius="50%"
                    />
                  </Box>

                  <Box mt="3.25px">
                    {formatMessage({
                      id: "campaignBuild.widgetPreview.notification",
                    })}
                  </Box>
                </Box>
              </Box>
            </>
          )}
          {widgetTab === 1 && (
            <Box
              style={{
                padding: "19.5px",
                overflowWrap: "break-word",
                overflow: "auto",
                height: "510px",
              }}
            >
              {title ? (
                <Box
                  mb="3.25px"
                  className="tableValue"
                  fontWeight={600}
                  fontSize={13}
                  color={isLight ? "#383838" : "rgba(255, 255, 255, 0.87)"}
                >
                  {title}
                </Box>
              ) : (
                <Box
                  width="221px"
                  height="16px"
                  bgcolor={isLight ? "#DEDEDE" : "rgba(222, 222, 222, 0.24)"}
                  borderRadius="8px"
                  mb="4px"
                />
              )}
              <Box
                fontSize={9.75}
                fontWeight={400}
                color={"#A5A5A5"}
                mb="16.25px"
              >
                {sendTime
                  ? formatDate(sendTime, { time: true })
                  : formatDate(Date.now(), { time: true })}
              </Box>
              {!image && !content ? (
                <>
                  <Box
                    width="100%"
                    height="16px"
                    bgcolor={isLight ? "#EDEDED" : "rgba(237, 237, 237, 0.10)"}
                    borderRadius="8px"
                    mb="8px"
                  />
                  <Box
                    width="100%"
                    height="16px"
                    bgcolor={isLight ? "#EDEDED" : "rgba(237, 237, 237, 0.10)"}
                    borderRadius="8px"
                    mb="8px"
                  />
                  <Box
                    width="112px"
                    height="16px"
                    bgcolor={isLight ? "#EDEDED" : "rgba(237, 237, 237, 0.10)"}
                    borderRadius="8px"
                    mb="8px"
                  />
                </>
              ) : (
                <>
                  {image && (
                    <div style={{ marginTop: 5 }}>
                      <img src={image} width="100%" height="auto" />
                    </div>
                  )}
                  <StyledDescription sx={{ my: "16.25px" }} isLight={isLight}>
                    {parse(content)}
                  </StyledDescription>
                </>
              )}
            </Box>
          )}
        </Box>
      </Box>
    );
  };

  return (
    <Box
      padding={"24.5px 32px 20px"}
      width="100%"
      textAlign="center"
      bgcolor="#EDEDED"
      overflow="scroll"
      sx={{ opacity: disabled ? 0.5 : 1 }}
    >
      <Box width="100%">{renderWidget()}</Box>
      <Box
        className="item-flex"
        m="15.5px auto 50px"
        justifyContent="center"
        color="#555"
      >
        <i
          className="meta-crm-icon-ic_arrow-left font-size-24"
          style={{
            cursor: widgetTab === 1 ? "pointer" : "not-allowed",
            color: widgetTab === 1 ? "#555" : "#A5A5A5",
          }}
          onClick={() => setWidgetTab(0)}
        />
        <Box mx="32px">{tabsArray[widgetTab]}</Box>
        <i
          className="meta-crm-icon-ic_arrow-right font-size-24"
          style={{
            cursor: widgetTab === 0 ? "pointer" : "not-allowed",
            color: widgetTab === 0 ? "#555" : "#A5A5A5",
          }}
          onClick={() => setWidgetTab(1)}
        />
      </Box>
    </Box>
  );
};

export default WidgetPreview;
